export default "__VITE_ASSET__CwCxLcru__"